import IRequiredDocumentDetailCategory from "@/module/main/dto/IRequiredDocumentDetailCategory";
import IRequiredDocumentDetail from "@/module/main/dto/IRequiredDocumentDetail";

export class RequiredDocumentDetail implements IRequiredDocumentDetail
{
    constructor(
        public category: IRequiredDocumentDetailCategory
    )
    {
    }
}
